import { useCommonActionSubscriptions } from './actions/use-common-actions-subscriptions';
import { useNotificationActionSubscription } from './actions/use-notification-action-subscription';
import { useNotification } from './use-notification';

export const useScheduleRequestNotification = (openSchedulePulseWithApptRequestTab: () => void) => {
  const { create, remove } = useNotification<'schedule-request-new'>();

  useCommonActionSubscriptions('schedule-request-new');
  useNotificationActionSubscription('schedule-request-new', 'view', ({ notification }) => {
    openSchedulePulseWithApptRequestTab();
    remove(notification.id);
  });

  return {
    create,
    remove,
  };
};
